import ResetFiltersSortersButton from "../../../common/filters/ResetFiltersSortersButton";
import {AssetsFiltersFE, AssetsSortersFE} from "../../../../types/internal/tables/assetsTable";
import _ from "lodash";

interface ResetFiltersSortersCreationAreasProps {
  filters: AssetsFiltersFE,
  sorters: AssetsSortersFE,
  resetFilters: () => void,
  resetSorters: () => void,
  resetPagination: () => void,
}
export default function ResetFiltersSortersCreationAreas({
  filters,
  sorters,
  resetFilters,
  resetSorters,
  resetPagination,
}: ResetFiltersSortersCreationAreasProps) {
  const isDisabled = _.isEmpty(filters) && _.isEmpty(sorters);

  return <ResetFiltersSortersButton onConfirm={() => {
    resetFilters();
    resetSorters();
    resetPagination();
  }} isDisabled={isDisabled} />;
}

